import { useState } from "react";
import { X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/i18n/LanguageContext";

export const WelcomeCode = () => {
  const { welcome, applyCode, removeCode } = useCart();
  const { t } = useLang();
  const [value, setValue] = useState(welcome.valid ? "" : welcome.code);
  const [busy, setBusy] = useState(false);
  const [tried, setTried] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await applyCode(value);
    } catch {
      /* network hiccup; leave as is */
    } finally {
      setTried(true);
      setBusy(false);
    }
  };

  if (welcome.valid) {
    return (
      <div data-testid="welcome-code-applied" className="mb-5 flex items-center justify-between border border-dashed border-[#B5A642]/50 rounded-sm px-3 py-2">
        <span className="font-ledger text-[12px] text-[#B5A642]">
          {welcome.code} · {welcome.kind === "treat"
            ? t("birthday treat, $5 off this order", "gâterie d'anniversaire, 5 $ de rabais")
            : t("free carriage on this order", "livraison gratuite sur cette commande")}
        </span>
        <button data-testid="welcome-code-remove" onClick={removeCode} aria-label={t("Remove code", "Retirer le code")} className="p-1 text-[#D3CEC4]/50 hover:text-[#E8DDC7] transition-colors">
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="mb-5" data-testid="welcome-code-form">
      <div className="flex gap-2">
        <input
          data-testid="welcome-code-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={t("Welcome or birthday code", "Code de bienvenue ou d'anniversaire")}
          className="flex-1 min-w-0 bg-transparent border border-[#303B2D] rounded-sm px-3 py-2 font-ledger text-[13px] uppercase tracking-[0.15em] text-[#E8DDC7] placeholder:normal-case placeholder:tracking-normal placeholder:text-[#D3CEC4]/35 focus:outline-none focus:border-[#B5A642]/70 transition-colors"
        />
        <button
          data-testid="welcome-code-apply"
          disabled={busy || !value.trim()}
          className="px-4 border border-[#B5A642]/60 text-[11px] uppercase tracking-[0.2em] text-[#D3CEC4] rounded-sm hover:bg-[#B5A642]/10 transition-colors disabled:opacity-40"
        >
          {t("Apply", "Appliquer")}
        </button>
      </div>
      {tried && !welcome.valid && welcome.code && (
        <p data-testid="welcome-code-error" className="mt-2 text-[11px] text-[#C9876B]">
          {welcome.reason === "used"
            ? t("That code has already travelled once.", "Ce code a déjà servi une fois.")
            : welcome.reason === "expired"
            ? t("That birthday treat has passed its date.", "Cette gâterie d'anniversaire est expirée.")
            : t("We don't recognise that code.", "Nous ne reconnaissons pas ce code.")}
        </p>
      )}
    </form>
  );
};
